import React from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { SIZE } from '@motorway/mw-highway-code/enums';

import { HIGH_DEMAND_VEHICLE_EVENTS } from 'Utilities/analytics/analyticsHighDemandVehicle';

import { Tooltip } from 'Storybook/components/local/Tooltip/Tooltip';

import { HighDemandFireIcon } from './HighDemandFireIcon';
import LocalTexts from './HighDemandVehicle.texts.json';

import styles from './HighDemandVehicle.module.scss';

const LocalT = new MDText(LocalTexts);

type HighDemandTooltipProps = {
  className?: string;
  placement?: 'bottom' | 'top';
};

export const HighDemandTooltip = ({ className, placement = 'top' }: HighDemandTooltipProps) => {
  const tooltipText = String(LocalT.translate('tooltip'));

  return (
    <Tooltip
      maxWidth={256}
      onShow={() => {
        HIGH_DEMAND_VEHICLE_EVENTS.TOOLTIP_APPEARED(tooltipText);
      }}
      overlay={<div>{tooltipText}</div>}
      {...{ placement }}
    >
      <button
        aria-label={tooltipText}
        className={cx(styles.chip, className)}
        data-testid='highDemandTooltipTrigger'
        type='button'
      >
        <HighDemandFireIcon size={SIZE.XSMALL} />
      </button>
    </Tooltip>
  );
};
